import { Deserializable } from './deserializable.model';
import { ProductOption } from './product-option.model';
import { PhotographyCatalogSelection } from './photography-catalog-selection.model';

export class VendorOverrides implements Deserializable<VendorOverrides> {
  catalog?: PhotographyCatalogSelection;
  code: string;
  modifiedOptions: ProductOption[];
  priceAdjustment: number;
  vendorCost?: number;
  quantity?: number;
  maxOptionsSelectable?: number;

  constructor(input?: any) {
    this.deserialize(input);
  }

  deserialize(input?: any): VendorOverrides {
    if (!input) { return this; }
    Object.assign(this, input);

    if (this.modifiedOptions) {
      this.modifiedOptions = this.modifiedOptions.map((option) => new ProductOption(option));
    }
    return this;
  }
}
